import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ab48f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-heap"]
const _hoisted_2 = { slot: "dialog-body" }

import {SliceZone} from '@prismicio/vue';
    import {provide, ref} from 'vue';
    import OptimizedImage from './OptimizedImage.vue';
    import {components} from '@/unlogged/slices';
    import {useCountry} from '@/unlogged/composables/useCountry';
    import {UserInfo} from '@/unlogged/types/custom';
    import {useUserInfoHelpers} from '@malt/vue-prismic';
    import {CountrySliceSlice} from '@/unlogged/prismicio';
    import {RESET_SELECTED_HOST} from '@/unlogged/keys';

    type Props = {
        countrySlice?: CountrySliceSlice;
        locale?: string;
        userInfo?: UserInfo | null;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelection',
  props: {
    countrySlice: null,
    locale: null,
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
        countrySlice?: CountrySliceSlice;
        locale?: string;
        userInfo?: UserInfo | null;
    };

    const {getCountry} = useCountry();

    const {isUserInfo} = useUserInfoHelpers();

    const onDialogShowCallBack = ref<() => void>();
    provide(RESET_SELECTED_HOST, onDialogShowCallBack);

    

    const [lang, countryCode] = props.locale?.split('-') ?? ['fr', 'fr'];

    const currentCountry = ref(props.countrySlice && getCountry(props.countrySlice.items, countryCode));

    function onDialogShow() {
        onDialogShowCallBack?.value?.();
    }

    function isNotConnected() {
        return !props.userInfo || !isUserInfo(props.userInfo) || !props.userInfo.firstName;
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_dialog_trigger = _resolveComponent("joy-dialog-trigger")!
  const _component_joy_dialog = _resolveComponent("joy-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'country-selection': true, 'unlogged': isNotConnected()})
  }, [
    _createVNode(_component_joy_dialog_trigger, { dialog: "countrySelectionDialog" }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "country-button",
          "data-heap": __props.countrySlice?.primary.buttonHeapId,
          onClick: onDialogShow
        }, [
          (!!currentCountry.value)
            ? (_openBlock(), _createBlock(OptimizedImage, {
                key: 0,
                "prismic-image": currentCountry.value.countryIcon,
                height: "14",
                width: "14",
                alt: _unref(lang).toUpperCase()
              }, null, 8, ["prismic-image", "alt"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(lang).toUpperCase()), 1)
        ], 8, _hoisted_1)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_joy_dialog, { id: "countrySelectionDialog" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (__props.countrySlice)
              ? (_openBlock(), _createBlock(_unref(SliceZone), {
                  key: 0,
                  slices: [__props.countrySlice],
                  components: _unref(components)
                }, null, 8, ["slices", "components"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]))
  ], 2))
}
}

})